
const moment = require('moment');
require('moment/locale/pt-br');
moment.locale('pt-br');

export  { moment };
